import { useEffect, useMemo, useState } from "react";

export const useIsExternalLink = (href: string) => {
  const externalCheck = useMemo(() => href.startsWith("//") || href.startsWith("http"), [href]);
  const [isExternal, setIsExternal] = useState(externalCheck);

  useEffect(() => {
    // Update isExternal when mounting clientside
    setIsExternal(externalCheck && !href.startsWith(window.location.href));
  }, [href, externalCheck]);

  return isExternal;
};
